import React, { Component } from 'react';
import './style.css';


class Header extends Component {
    render() {
        return (

            <div className={this.props.headerBackColor === 'transparent' ? 'header' : 'header-fix'}>
                <header className={this.props.headerBackColor === 'transparent' ? "header-withoutbg" : "header-withbg"}>
                    <div className="brand-name">
                        <span>
                            <a href="/" >
                                <img src={require('./../../assets/images/Logo.png')} width="200" height="200" alt=""
                                    style={{ marginTop: '15px' }} className='logo-height-width' />
                            </a>
                        </span>
                    </div>
                </header>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/checkastronow/components/header/header.js